import { render, staticRenderFns } from "./MarketGroup.vue?vue&type=template&id=5d42844b"
import script from "./MarketGroup.vue?vue&type=script&lang=js"
export * from "./MarketGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports